export default __webpack_public_path__ + "static/media/errorImg.25039539.png";